import type { Mesh, Object3D } from 'three';
import { disposeMaterial } from './material-utility';

export function disposeObjectRecursively(object3D: Object3D): void {
  disposeObject(object3D);
  for (const child of object3D.children) {
    disposeObjectRecursively(child);
  }
}

export function disposeObject(object: Object3D): void {
  // Cast it to a mesh so that we access the properties in typescript.
  const mesh = object as Mesh;
  if (mesh.geometry) {
    mesh.geometry.dispose();
    mesh.geometry = undefined;
  }
  if (mesh.material) {
    const materials = Array.isArray(mesh.material) ? mesh.material : [mesh.material];
    for (const material of materials) {
      disposeMaterial(material);
    }
  }
}
